import { parseLocale } from 'lib/constants/localization'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import _useTranslation from 'lib/hooks/_useTranslation'
import SearchResults from 'components/feature/App/pages/SearchResults'
import { useEffect } from 'react'

import Meta from 'components/modules/SEO/Meta'
import styled from 'styled-components'
import { searchResultRoute } from 'lib/constants/routes'
import { isDeviceMobile } from 'lib/features/deviceInfo'

const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    position: relative;
    background: transparent;
    &::after {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: linear-gradient(180.02deg, #150620 0.01%, #14183a 50%, #150620 99.99%);
        z-index: -1;
        pointer-events: none;
    }
    @media (max-width: 750px) {
        section {
            padding: 20px 0px;
        }
    }
`

const SearchKnows = () => {
    const { t } = _useTranslation('app')
    const isMobile = isDeviceMobile()

    return (
        <Container>
            <section className="no-padding-top">
                <Meta title={t('app/searchsectionTitle')} description="" />

                <SearchResults searchUrl={searchResultRoute} isApp={false} autoFocus={isMobile} isDarkTheme={true} />
            </section>
        </Container>
    )
}

export default SearchKnows

export const getStaticProps: GetStaticProps = async (props) => ({
    props: {
        ...(await serverSideTranslations(parseLocale(props.locale).interfaceLanguageCode, [
            'common',
            'app',
            'knows',
            'plusPlan',
        ])),
    },
})
